// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"d6d8d61a","727":"64f443a1"}[chunkId] + ".chunk.js";
};